// extracted by mini-css-extract-plugin
module.exports = {"container":"Action_container__3tzdz","center":"Action_center__3_qkG","body":"Action_body__1-Hoo","iframe":"Action_iframe__28EIn","iframeContainer":"Action_iframeContainer__1RwOP"};